<template>
  <div>
    <div v-if="pjList.length" class="wrap">
      <div class="part1">
        <div class="top">
          <h5>
            <span>达人排竞信息</span>
          </h5>
        </div>
        <div class="tips"><i class="vxe-icon-warning-circle"></i>该达人目前已排期确定参与推广的游戏或游戏类型如下，若您有合作意向且营销标的与此类似，请谨慎考虑，以免撞档。</div>
        <vxe-table :data="pjList" :column-config="{ resizable: true }" :border="false" :show-header-overflow="true" :show-overflow="true" :show-footer="false" :align="'center'">
            <vxe-column field="" title="排竞日期">
              <template #default="{ row }">
                <span>{{ row.start_time }} 至 {{ row.end_time }}</span><span style="color:#FF6F28"> (还有{{ row?.end_time ? getDaysRemaining(row?.end_time) : '-' }}天排竞结束)</span>
              </template>
            </vxe-column>
            <vxe-column field="competitive_product" title="排竞游戏或类型"></vxe-column>
        </vxe-table>
      </div>
    </div>
    <div v-if="supplierList.length" class="wrap">
      <div class="part1">
        <div class="top">
          <h5 class="fx-between">
            <span>供应商信息</span>
            <el-button type="text" @click="() => isSupplierListExpand = !isSupplierListExpand">
                <span v-if="isSupplierListExpand">收起<i class="el-icon-arrow-down"></i></span>
                <span v-else>展开<i class="el-icon-arrow-up"></i></span>
            </el-button>
          </h5>
        </div>
        <vxe-grid v-show="isSupplierListExpand" v-bind="supplierGridOptions" :data="supplierList" :row-class-name="rowClassName">
            <template #suppliers_name="{row}">
                <div>{{ row.suppliers_name }}</div>
                <div v-if="row.is_black == 1" style="color: #1D2129;">（该供应商已被拉黑）</div>
            </template>
        </vxe-grid >
      </div>
    </div>
    <!-- 近期综合表现 -->
    <div class="wrap">

      <div class="part1">
        <div class="top">
          <h5>
            <span>近期综合表现</span>
            <el-tooltip placement="top">
              <div slot="content">180天内，最近5个发布满7天的原创稿件（充电专属视频除外）和动态</div>
              <i class="vxe-icon-question-circle"></i>
            </el-tooltip>
          </h5>
          <i>更新时间: {{darenInfo.log_date || "-"}}</i>
        </div>
        <div class="part-title">
          <img class="title-icon" src="../images/jqzhbx/gjsj.png" alt="">
          <span>稿件数据</span>
        </div>
        <ul class="panel-wrap">
          <li>
              <p>播放量中位数</p>
              <p>{{darenInfo.average_play_cnt||"-"}}</p>
          </li>
          <li>
              <p>互动率中位数</p>
              <p>{{darenInfo.average_interactive_rate||"-"}}</p>
          </li>
          <li>
              <p>点赞中位数</p>
              <p>{{darenInfo.average_like_cnt||"-"}}</p>
          </li>
          <li>
              <p>评论中位数</p>
              <p>{{darenInfo.average_comment_cnt||"-"}}</p>
          </li>
          <li>
              <p>弹幕中位数</p>
              <p>{{darenInfo.average_barrage_cnt||"-"}}</p>
          </li>
          <li>
              <p>收藏中位数</p>
              <p>{{darenInfo.average_collect_cnt||"-"}}</p>
          </li>
        </ul>
        <div class="part-title">
          <img class="title-icon" src="../images/jqzhbx/gjld.png" alt="">
          <span>稿件亮点</span>
          <el-tooltip placement="top">
              <div slot="content">统计{{['','近30天','近90天','近180天'][dateType]}}内，发布满7天的原创稿件（充电专属视频除外）数据</div>
              <i class="vxe-icon-question-circle"></i>
          </el-tooltip>
          <div class="right">
            <el-radio-group v-model="dateType" class="custom-tab" @change="onhighlightDataType">
              <el-radio-button label="1">近30天</el-radio-button>
              <el-radio-button label="2">近90天</el-radio-button>
              <el-radio-button label="3">近180天</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <ul v-loading="loadingObj.highData" class="highlightsData">
          <li>
              <p>投稿数</p>
              <p>{{highData.avid_cnt || '-'}}</p>
          </li>
          <li>
              <p>热门稿件数</p>
              <p>{{highData.hot_cnt || '-'}}</p>
          </li>
          <li>
              <p>
                爆款视频数
                <el-tooltip placement="top">
                  <div slot="content">各分区高播放粉比视频</div>
                  <i class="vxe-icon-question-circle"></i>
                </el-tooltip>
              </p>
              <p>{{highData.explode_cnt || '-'}}</p>
          </li>
        </ul>
        <div class="part-title">
          <img class="title-icon" src="../images/jqzhbx/zx10gspqs.png" alt="">
          <span>最新10个视频趋势</span>
          <el-tooltip placement="top">
              <div slot="content">180天内，最近10个发布满7天的原创稿件（充电专属视频除外）播放量</div>
              <i class="vxe-icon-question-circle"></i>
          </el-tooltip>
          <div class="right">
            <el-radio-group class="custom-tab" v-model="tab1Position" @change="part1Tab1">
              <el-radio-button label="播放量" name="播放量">播放量</el-radio-button>
              <el-radio-button label="点赞量" name="点赞量">点赞量</el-radio-button>
              <el-radio-button label="评论量" name="评论量">评论量</el-radio-button>
              <el-radio-button label="弹幕量" name="弹幕量">弹幕量</el-radio-button>
            </el-radio-group>
          </div>
        </div>
        <p class="text1">
          最高播放量 <span class="high-light"> {{maxCount}} </span> 最低播放量 <span class="high-light">{{minCount}}</span>
        </p>
        <BarChart2 v-loading="loadingObj.videoChart" :barChart2Info="videoChartData" ref="videoChart"></BarChart2>
      </div>
      <!-- <div class="part3" style="display:none;">
        <div class="top">
          <h5>作品案例</h5>
          <el-radio-group class="tab clear" v-model="tab2Position" @change="part2Tab1">
            <el-radio-button label="个人作品">个人作品</el-radio-button>
            <el-radio-button label="商业作品">商业作品</el-radio-button>
          </el-radio-group>
        </div>
        <div class="vodieContainer">
          <a v-for="item in videoData" :key="item.title" :href="item.bv_id" target="_blank">
            <div class="left">
              <img :src="item.cover" alt="">
              <span class="time">{{item.duration}}</span>
            </div>
            <div class="right">
              <div class="top">
                <div class="item"><span>播放数</span><span>{{item.play_cnt}}</span></div>
                <div class="item"><span>点赞数</span><span>{{item.like_cnt}}</span></div>
                <div class="item"><span>评论数</span><span>{{item.comment_cnt}}</span></div>
              </div>
              <div class="bottom">
                {{item.title}}
              </div>
            </div>
          </a>
        </div>
      </div> -->
    </div>
  </div>
</template>

<script>
import tools from "../../../components/tools/tools.js";
import BarChart2 from '../../../components/Echart/BarChart2.vue';
import { apiCache } from "@/utils/index.js"
export default {
  // props:["fatherDarenInfo"],
  props: {
    'fatherDarenInfo':{
        type: Object,
        default:()=>({})
     },
     'supplierList':{
        type: Array,
        default:()=>([])
     }
  },
  data(){
    return {
      pjList:[],
      darenInfo:{},
      dateType:'1',
      tab1Position:"播放量",

      videoChartData:{
        nodeId:'videoChart',//节点
        data: [0],//数据
        xAxisData:['-'],
        yAxisName: '播放量',
        xShow:'false',
        unit:''
      },
      //性别分布
      sexDistributionData:{
        nodeId:'sexChart',//节点
        data: [{value: 0, name: '女性'},{value: 0, name: '男性'},],//数据
        color:["#ff5c00","#40a0fc"],
        guideline:false,
        unit:'%'
      },
      //设备分布
      equipmenDistributionData: {
        nodeId: "equipmenChart", //节点
        data: [{
            value: 0,
            name: "-"
          }
        ], //数据, //数据
        color: ["#2074ff",
          "#38a1ff",
          "#77bfff",
          "#a7d6ff",
          "#d0e9ff",
          "#def0ff",],
        unit: "%",
        guideline: false, //引导线
      },
      //年龄分布
      ageDistributionData: {
        nodeId: "ageChart", //节点
        data: [{
            value: 0,
            name: "-"
          }
        ], //数据
        color: ["#2074ff",
          "#38a1ff",
          "#77bfff",
          "#a7d6ff",
          "#d0e9ff",
          "#def0ff",],
        unit: "%",
        guideline: false, //引导线
      },
      // 地域分布
      areaPercentageData:{
        nodeId:'areaChart',//节点
        data: [],//数据
        text:["高(%)","低(%)"]
      },
      top5Area:[],
      // 视频信息
      videoData:[],
      maxCount:'-', //最大播放量
      minCount:'-', //最小播放量

      //稿件亮点数据
      highData:{},

      loadingObj: {
        highData: false,
        videoChart: false
      },
      supplierGridOptions: {
          border: 'inner',
          maxHeight: '380',
          columns: [
              { field: 'product_name', title: '产品类型' },
              { field: 'account_type', title: '账号类型' },
              { field: 'suppliers_name', title: '供应商', slots: { default:'suppliers_name' } },
              { field: 'devidedrate', title: '媒体侧自然返点%' },
          ],
      },
      isSupplierListExpand: true
    }
  },
  components:{
    BarChart2,
  },
  methods:{
    isAfterToday(targetTime) {
          // 将目标时间字符串转换为 Date 对象
          const targetDate = new Date(targetTime.replace(/-/g, '/'));
          // 获取当前日期并设置时间为 00:00:00
          const today = new Date();
          today.setHours(0, 0, 0, 0);
          // 比较目标时间是否在今天及之后
          let isFlag = targetDate >= today;
          return isFlag;
        },
    getDaysRemaining(dateStr) {
            const today = new Date();
            today.setHours(0, 0, 0, 0); // 将时间设置为当天的零点，避免时间影响

            const targetDate = new Date(dateStr);
            if (isNaN(targetDate.getTime())) {
                console.error('输入的日期格式不正确，请使用 "YYYY-MM-DD" 格式。');
                return null;
            }

            const oneDay = 24 * 60 * 60 * 1000; // 一天的毫秒数
            const diffTime = targetDate - today;
            return Math.round(diffTime / oneDay);
        },
    async getPjTableData() {
        if(!this.$route.query.mid){
          return
        }
        let params = {
            mid: this.$route.query.mid,
        };
        const res = await this.$axios.post(`/api.php?m=detail|api|gx&a=getCompetitive`, params)
        this.pjList = res.filter(x => {
              return this.isAfterToday(x.end_time)
            }) || [];
    },
    initDarenInfo(val){
      let obj = {}
      // 近期综合表现
      obj.log_date = val.log_date
      obj.average_play_cnt = tools.setW(val.average_play_cnt)
      obj.average_interactive_rate = tools.scale(val.average_interactive_rate)
      obj.average_comment_cnt = tools.setW(val.average_comment_cnt)
      obj.average_like_cnt = tools.setW(val.average_like_cnt)
      obj.average_barrage_cnt = tools.setW(val.average_barrage_cnt)
      obj.average_collect_cnt = tools.setW(val.average_collect_cnt)
      // 圈层触达
      let sexDistributionData={
        nodeId:'sexChart',//节点
        data: [{value: val.sax_distributions_audience[1].count, name: '女性'},{value: val.sax_distributions_audience[0].count, name: '男性'}],//数据
        color:["#ff5c00","#40a0fc"],
        guideline:false,
        unit:'%'
      }
      let equipmenDistributionData = {
        nodeId: "equipmenChart", //节点
        data: [], //数据
        color: ["#2074ff",
          "#38a1ff",
          "#77bfff",
          "#a7d6ff",
          "#d0e9ff",
          "#def0ff",],
        unit: "%",
        guideline: false, //引导线
      }
      let ageDistributionData = {
        nodeId: "ageChart", //节点
        data: [], //数据
        color: ["#2074ff",
          "#38a1ff",
          "#77bfff",
          "#a7d6ff",
          "#d0e9ff",
          "#def0ff",],
        unit: "%",
        guideline: false, //引导线
      }
      let areaPercentageData = {
        nodeId:'areaChart',//节点
        data: [],//数据
        text:["高(%)","低(%)"]
      }
      val.device_distributions_audience.map(item=>{
        equipmenDistributionData.data.push({
          value: item.count,
          name: item.section_desc
        })
      })
      val.age_distributions_audience.map(item=>{
        ageDistributionData.data.push({
          value: item.count,
          name: item.section_desc
        })
      })
      val.top_region_distributions_audience.map(item=>{
        areaPercentageData.data.push({
          value: item.count,
          name: item.section_desc
        })
      })

      let top5Area = []
      let areadata2 = JSON.parse(JSON.stringify(areaPercentageData))
      top5Area[0] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      top5Area[1] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      top5Area[2] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      top5Area[3] = areadata2.data[tools.arraObjMax(areadata2.data)]
      areadata2.data.splice(tools.arraObjMax(areadata2.data),1)
      top5Area[4] = areadata2.data[tools.arraObjMax(areadata2.data)]


      this.darenInfo = obj
      this.sexDistributionData = sexDistributionData
      this.equipmenDistributionData = equipmenDistributionData
      this.ageDistributionData = ageDistributionData
      this.areaPercentageData = areaPercentageData
      this.top5Area = top5Area

    },
    part1Tab1(val){
      this.tab1Position = val
      if(val==="播放量"){
        this.fetchBlTrendData('getBlTrend',3)
      }else if(val==="点赞量"){
        this.fetchBlTrendData('getBlTrend',4)
      }else if(val==="评论量"){
        this.fetchBlTrendData('getBlTrend',5)
      }else if(val==="弹幕量"){
        this.fetchBlTrendData('getBlTrend',6)
      }
    },

    initVideoChartData(val){
      let videoChartData={
        nodeId:'videoChart',//节点
        data: [],//数据
        xAxisData:[],
        yAxisName: '播放量',
        xShow:'false',
        unit:''
      }
      val?.upper_draft_trend_info_vos?.forEach?.(item=>{
        videoChartData.data.push(item.trend_cnt)
        videoChartData.xAxisData.push(item.title+"<br/>时间："+item.pub_date)
      })
      this.videoChartData = videoChartData
      this.minCount = tools.setW(val.min_cnt)
      this.maxCount = tools.setW(val.max_cnt)
    },
    async onhighlightDataType(){
      this.loadingObj.highData = true
      const res = await this.$api.getBZhanData.getBlHighlights({
        upper_mid: this.$route.query.up_id,
        type: this.dateType
      })
      this.loadingObj.highData = false
      const data = res.data.data
      data.avid_cnt = tools.setW(data.avid_cnt)
      data.hot_cnt = tools.setW(data.hot_cnt)
      data.explode_cnt = tools.setW(data.explode_cnt)
      this.highData = data
    },
    // 获取UP主最新作品
    async fetchBlTrendData(key,type){
      try {
        this.loadingObj.videoChart = true
        const res = await apiCache(key+type,()=> this.$api.getBZhanData.getBlTrend(`?upper_mid=${this.$route.query.up_id}&trend_type=${type}`))
        this.loadingObj.videoChart = false
        if(res.data.code!==0){return}
        this.initVideoChartData(res.data.data)
        this.$refs.videoChart.barChart2(this.videoChartData)
      } catch (error) {
        console.log('error :>> ', error);
      }
    },
    rowClassName ({ row }) {
        if (row.is_black == 1) {
            return 'row-gray'
        }
        return null
    },
  },
  created(){
    this.initDarenInfo(this.fatherDarenInfo)
    this.onhighlightDataType();
    this.getPjTableData();
  },
  mounted(){
    this.fetchBlTrendData('getBlTrend',3)
  }
}
</script>


<style lang="scss" scoped>
.tips {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: #4A5569;
    margin-bottom: 15px;
    i {
        color: #ff6f28;
        margin-right: 8px;
    }
}
.part1{
  .part-title{
    display: flex;
    position: relative;
    align-items: center;
    i{
      vertical-align: middle;
      font-size: 14px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #999999;
      margin-left: 8px;
    }
    .title-icon{
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .right{
      margin-left: auto;
      margin-right: 0;
    }
  }
  .panel-wrap,.highlightsData{
    margin: 0;
    padding: 30px 0;
    box-sizing: border-box;
    display: flex;
    li{
      flex: 1;
      border-right: 1px solid #F0F0F0;
      list-style:none;
      text-align: center;
      box-sizing: border-box;
      p{
        text-align: center;
        &:first-of-type{
          font-size: 14px;
          color:rgb(51, 51, 51);
          font-weight: 400;

        }
        &:nth-of-type(2){
          font-size: 18px;
          font-weight: bold;
          color:rgb(255,111,40);
        }
      }
      &:nth-last-of-type(1){
          border: 0;
      }
    }
  }
}

.top{
    i{
      display: inline-block;
      margin-left: 10px;
      font-size: 14px;
      font-family: OPPOSans;
      font-weight: 400;
      color: #999999;
    }
}

#videoChart{
  margin-top: 10px;
  height: 266px;
}

::v-deep .vxe-table .vxe-body--row.row-gray{
    background-color: #F2F3F5;
}
.fx-between{
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
</style>